module.exports = __webpack_public_path__ + "static/media/asist.cc0c4df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/asist.png
// module id = 751
// module chunks = 0